import { useCallback } from "react";
import { useAppNavigate } from "../global-hooks";
import { loginAction } from "../../actions/admin";
import {
  changeEmail,
  changePassword,
  setAlertMessage,
} from "../reducers/login.reducer";

export const useHandleLoginAlertMessage = (dispatch: Function) => {
  const handleAlertMessage = useCallback(
    (message: string | null) => {
      dispatch(setAlertMessage(message));
    },
    [dispatch]
  );
  return handleAlertMessage;
};

export const useHandleLoginEmailChange = (dispatch: Function) => {
  const handleEmailChange = useCallback(
    (event: string) => {
      dispatch(changeEmail(event));
    },
    [dispatch]
  );
  return handleEmailChange;
};

export const useHandleLoginPasswordChange = (dispatch: Function) => {
  const handlePasswordChange = useCallback(
    (event: string) => {
      dispatch(changePassword(event));
    },
    [dispatch]
  );
  return handlePasswordChange;
};

export const useHandleLoginNavigate = () => {
  const navigate = useAppNavigate();
  const handleForgotPasswordClick = useCallback(() => {
    navigate("/forgot-password");
  }, [navigate]);
  return handleForgotPasswordClick;
};

export const useHandleLogin = () => {
  const handleButtonClick = useCallback(async () => {
    await loginAction();
  }, []);
  return handleButtonClick;
};
